import axios from 'axios'
import axiosRetry from 'axios-retry/dist/cjs/index'

// const axiosClient = axios.create()

// Configure axios-retry to retry 3 times on failure
axiosRetry(axios, {
  retries: 3,
  // Exponential backoff: 100ms, 200ms, 400ms, 800ms, 1600ms
  retryDelay: axiosRetry.exponentialDelay,
  retryCondition: (error) => {
    // Retry only on network errors or 5xx server errors
    return axiosRetry.isNetworkOrIdempotentRequestError(error) ||
      (error.response && error.response.status >= 500)
  },
})

// Function to generate a unique ID
function generateRequestId() {
  // Use crypto.randomUUID() for a standard UUID (Node.js/modern browsers)
  // or a simple alternative if needed
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  } else {
    // Fallback for older environments
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
  }
}

// Add a request interceptor
axios.interceptors.request.use(
  (config) => {
    // Generate a new request ID for each request
    const requestId = generateRequestId()

    // Add the request ID to the headers
    // The header name is typically 'X-Request-Id' or similar
    config.headers['X-Request-Id'] = requestId

    return config
  },
  (error) => {
    // Handle request error
    return Promise.reject(error)
  }
)

const originalGet = axios.get

function generateRequestKey(url, config) {
  const keyData = {url}
  if (config && config.params) {
    keyData.params = config.params
  }
  return JSON.stringify(keyData)
}

const pendingRequests = {}
axios.get = function (url, config) {
  const requestId = generateRequestKey(url, config)

  if (pendingRequests[requestId]) {
    console.log('request queued:', requestId)
    return new Promise(pendingRequests[requestId].resolver)
  }

  const requests = []
  const resolver = (resolve, reject) => {
    requests.push({resolve, reject})
  }
  const res = originalGet(url, config)
  pendingRequests[requestId] = {
    res,
    requests,
    resolver,
  }

  res.then((data) => {
    requests.forEach((request) => request.resolve(data))
    pendingRequests[requestId] = null
  })
  res.catch((err) => {
    requests.forEach((request) => request.reject(err))
    pendingRequests[requestId] = null
  })

  return new Promise(pendingRequests[requestId].resolver)
}

export default axios



// WEBPACK FOOTER //
// ./src/lib/axiosClient.js